<template>    
  <Busy :value="busy"></Busy> 
</template>
<script>
  import { Busy } from '@itus/ui.common'
  export default {
    name: 'Signout',
    components: {
      Busy
    },
    data() {
      return {
        busy: true
      }
    },
    mounted() {
      this.busy = true
      this.$store.dispatch('logout')
        .finally(() => {              
          this.busy = false    
          this.$router.push('/signin')                  
        })
    }
  }
</script>